<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <loading-view/> -->
    <router-view></router-view>
  </div>
</template>

<script>
// import loadingView from '@/components/loading.vue'

export default {
  name: 'App',
  components: {
    // loadingView
  },
  created(){
    // this.$router.replace({
    //   // name:'chooseRoom',
    //   name:'mainPage',
    //   // name:'E501Room',
    //   // name:'testPage',
    // })
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: white;
  font-size: (28/40rem);
  /* margin-top: 60px; */
}
* {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
}

html{
  font-size: (100vw/750)*40 ;//vw适配
}
</style>
